import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/console/model',
  component: Layout,
  meta: {
    title: '模型',
    menu: false,
  },
  children: [
    {
      path: '',
      name: 'model',
      component: () => import('@/views/model/index.vue'),
      meta: {
        title: '模型',
        menu: false,
        breadcrumb: false,
      },
    },
    {
      path: ':modelId',
      name: 'model-detail',
      component: () => import('@/views/model/detail.vue'),
      meta: {
        title: '模型详情',
        menu: false,
        breadcrumb: true,
      },
    },
    {
      path: 'collection/:collectionId',
      name: 'model-collection-detail',
      component: () => import('@/views/model/collection-detail.vue'),
      meta: {
        title: '模型集合详情',
        menu: false,
        breadcrumb: true,
      },
    },
  ],
}

export default routes
